import React, { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const InfoIconHover: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <g id="icon-info-hover-24" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="info-hover-v2-24" fillRule="nonzero">
                    <circle id="Oval" fill="#F0F0F0" cx="12" cy="12" r="12" />
                    <path
                        d="M12.9,7.8 C12.9,7.9 12.9,8 12.8,8.1 C12.8,8.2 12.7,8.3 12.6,8.4 C12.5,8.5 12.4,8.5 12.3,8.6 C12.2,8.6 12.1,8.7 12,8.7 C11.9,8.7 11.8,8.7 11.7,8.6 C11.6,8.6 11.5,8.5 11.4,8.4 C11.3,8.3 11.3,8.2 11.2,8.1 C11.2,8 11.1,7.9 11.1,7.8 C11.1,7.7 11.1,7.6 11.2,7.5 C11.2,7.4 11.3,7.3 11.4,7.2 C11.5,7.1 11.5,7 11.7,7 C11.8,7 11.9,6.9 12,6.9 C12.1,6.9 12.2,6.9 12.3,7 C12.4,7 12.5,7.1 12.6,7.2 C12.7,7.3 12.7,7.4 12.8,7.5 C12.9,7.6 12.9,7.7 12.9,7.8 Z M12.6,10 L12.6,17.1 L11.4,17.1 L11.4,10 L12.6,10 Z"
                        id="Shape"
                        fill="#2D2D2D"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
